// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.browser-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4);
  text-align: center;
}

.browser-login-title {
  margin: 0;
}

.browser-login-hint {
  margin: 0;
  opacity: 0.85;
}

.browser-login-widget {
  min-height: 40px;
}

.browser-login-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
}

.browser-login-qr-img {
  width: 220px;
  height: 220px;
  background: #fff;
  border-radius: 8px;
}

.browser-login-link {
  color: inherit;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/features/browserLogin/BrowserLogin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".browser-login {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  text-align: center;\n}\n\n.browser-login-title {\n  margin: 0;\n}\n\n.browser-login-hint {\n  margin: 0;\n  opacity: 0.85;\n}\n\n.browser-login-widget {\n  min-height: 40px;\n}\n\n.browser-login-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.browser-login-qr-img {\n  width: 220px;\n  height: 220px;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.browser-login-link {\n  color: inherit;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
